/**
 * Performance timing utility for baseline comparison benchmarking.
 *
 * Usage:
 *   const timer = createTimer('My Operation');
 *   timer.start();
 *   // ... do work ...
 *   timer.lap('sub-step 1');
 *   // ... more work ...
 *   timer.lap('sub-step 2');
 *   // ... more work ...
 *   timer.end();
 *
 * Output format:
 *   ⏱ [My Operation] 2450ms
 *     └─ sub-step 1: 890ms
 *     └─ sub-step 2: 1200ms
 *     └─ remainder: 360ms
 */
export function createTimer(name) {
  const startTime = performance.now();
  const laps = [];

  return {
    start() {
      // already tracking from construction
    },

    lap(label) {
      laps.push({ label, time: performance.now() - startTime });
    },

    end() {
      const total = performance.now() - startTime;
      const output = [`⏱ [${name}] ${Math.round(total)}ms`];

      let lastLapTime = 0;
      laps.forEach((lap) => {
        const delta = Math.round(lap.time - lastLapTime);
        output.push(`  └─ ${lap.label}: ${delta}ms`);
        lastLapTime = lap.time;
      });

      const remainder = Math.round(total - lastLapTime);
      if (remainder > 10) {
        output.push(`  └─ remainder: ${remainder}ms`);
      }

      console.log(output.join('\n'));
      return total;
    },
  };
}
